export default "__VITE_ASSET__U1zTbfqK__"